import { render, staticRenderFns } from "./OnlyImage.vue?vue&type=template&id=701e2e8e"
import script from "./OnlyImage.vue?vue&type=script&lang=js"
export * from "./OnlyImage.vue?vue&type=script&lang=js"
import style0 from "./OnlyImage.vue?vue&type=style&index=0&id=701e2e8e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports